import { mcpConnectionTest } from "../mcpConnectionTest";
import { bearerAuth, oauthAuth, dcrOAuth } from "../standardAuthPatterns";
import { defineProduct, productVariant } from "../types";
import logo from "./logo.svg";

export const neonTech = defineProduct({
  name: "Neon",
  tagLine: "Serverless Postgres platform",
  logo,
  tags: ["data", "engineering"],
  variants: [
    productVariant({
      identifier: "neonTech",
      authLabel: "API key",
      protocol: "http",
      defaultUrlPattern: () => "https://console\\.neon\\.tech/.*",
      auth: (app) => bearerAuth(app.secret.apiKey),
      steps: [
        {
          title: "Get an API key",
          items: [
            {
              kind: "markdown",
              content:
                "Visit [Neon Console > Account Settings > API Keys](https://console.neon.tech/app/settings/api-keys) and create a new API key.",
            },
          ],
        },
        {
          title: "Copy and paste the API key into the field below",
          items: [
            {
              kind: "input",
              label: "API key",
              required: true,
              target: { kind: "secrets", field: "apiKey" },
            },
          ],
        },
      ],
      connectionTest: {
        protocol: "http",
        request: () => "https://console.neon.tech/api/v2/projects",
      },
    }),

    productVariant({
      identifier: "neonMcp",
      authLabel: "MCP OAuth",
      protocol: "http",
      defaultUrlPattern: () => "https://mcp\\.neon\\.tech/mcp(?:\\?.*)?$",
      auth: () => oauthAuth,
      oauth: dcrOAuth({
        serverUrl: "https://mcp.neon.tech/mcp",
        issuer: "https://mcp.neon.tech",
        authorizationEndpoint: "https://mcp.neon.tech/api/authorize",
        tokenEndpoint: "https://mcp.neon.tech/api/token",
        resource: "https://mcp.neon.tech/mcp",
        scopes: ["read"],
      }),
      steps: [
        {
          title: "Connect to Neon",
          items: [
            {
              kind: "markdown",
              content:
                "Sign in to Neon to authorize its MCP server. The default grants read access. Add write access only when your workflow needs to change databases or projects. For direct Neon REST API requests, use the API key connection.",
            },
            {
              kind: "input",
              label: "Scopes",
              helperText:
                "Optional space-separated scopes: read, write. Defaults to read.",
              target: { kind: "oauthConnection", field: "scopes" },
            },
            { kind: "oauth" },
          ],
        },
      ],
      connectionTest: mcpConnectionTest("https://mcp.neon.tech/mcp"),
      usageHint: () =>
        "Call Neon through streamable HTTP MCP at https://mcp.neon.tech/mcp. Load the mcp-client skill for the handshake and tool calls; authentication is injected automatically. Access is limited to the scopes approved during connection.",
    }),
  ],
});
